import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { COMPARISON_IMAGE } from "@/data/content";

export const BeforeAfter = () => (
  <div data-testid="before-after-slider" className="rounded-2xl overflow-hidden border border-white/10 cyan-glow">
    <ReactCompareSlider
      itemOne={
        <div className="relative w-full h-full">
          <ReactCompareSliderImage
            src={COMPARISON_IMAGE}
            alt="Regular photo print — before"
            style={{ filter: "grayscale(40%) contrast(80%) brightness(85%)" }}
          />
          <span className="absolute bottom-4 left-4 text-xs uppercase tracking-[0.2em] font-semibold bg-black/60 backdrop-blur-md px-4 py-2 rounded-full text-[#A1A1A6]">
            Regular Print
          </span>
        </div>
      }
      itemTwo={
        <div className="relative w-full h-full">
          <ReactCompareSliderImage
            src={COMPARISON_IMAGE}
            alt="MetalMuse metal print — after"
            style={{ filter: "brightness(115%) contrast(120%) saturate(150%)" }}
          />
          <span className="absolute bottom-4 right-4 text-xs uppercase tracking-[0.2em] font-semibold bg-[#00E5FF] px-4 py-2 rounded-full text-black">
            MetalMuse Metal
          </span>
        </div>
      }
      style={{ height: "min(60vh, 540px)", width: "100%" }}
    />
  </div>
);
